import { IonApp, 
  IonHeader, 
  IonToolbar, 
  IonTitle,
  IonRow,
  IonContent, 
  IonFooter, 
  IonMenu,
  IonList,
  IonListHeader,
  IonMenuToggle,
  IonIcon,
  IonLabel,
  IonPage ,
  IonButtons,
  IonButton,
  IonCol,
  IonModal,
  IonGrid,
  IonTextarea,
  IonItem,
  useIonAlert } from '@ionic/react';
import { useState } from "react";

import '../styles/VerifyLoginComponent.css'
import '../styles/UserSignInComponent.css'
import '../styles/style.css'
import superFetch from '../utils/superFetch';


function SidebarComponent (props){

  const [sideMenuList , setSideMenuList] = useState(['sidemenu-list active', 'sidemenu-list', 'sidemenu-list'])

  const handleMenuChange = (value) => {
    let newMenu = []
    for ( let i = 0 ; i < sideMenuList.length ; i++) {
      
      if (i === value) {
        newMenu.push('sidemenu-list active')
      } else {
        newMenu.push('sidemenu-list')
      }
    }
    setSideMenuList(newMenu)
  }

  const [isOpen, setIsOpen] = useState(false)

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [present] = useIonAlert()

  const sendEmail =  async () => {
    
            const formData = {
                "name": name,
                "email": email,
                "contactNumber": phone,
                "message": message,
            }
            
            try{
                // Captcha token is passes as the bearer token -even though its not JWT, for backend to verify if user cleared the captcha
                // var response = await axios.post(`${process.env.REACT_APP_SEND_API}/api/send/email`, formData,{ headers:{'Authorization':`Bearer ${captchaToken}`} })
                let response = await superFetch('/api/send/support/enquiry', "post", formData)
                
                if (response.status){
                    present({
                        header: 'Success',
                        message: "Email Sent Successfully",
                        buttons: [
                            'Okay',
                        ],
                        mode: 'ios',
                    })
                    setName('')
                    setEmail('')
                    setPhone('')
                    setMessage('')
                    setIsOpen(false)
                } else {
                    present({
                        header: 'Error',
                        message: response.data.error.message,
                        buttons: [
                            'Okay',
                        ],
                        mode: 'ios',
                    })
                }
            } catch (err) {
            }
}
  

  return (
      <>
  <IonMenu content-id="main-content">
    <IonToolbar>
      
    </IonToolbar>  
    <IonList className='sidebar-list mobile-view'>
      <div className='logout-card'>
          <ion-avatar slot="start">
            <img src="../img/ryde-profile.png" />
            
          </ion-avatar>
          <ion-label>
            <h2>RYDE Technologies Pte Ltd</h2>
            <p>{props.memberData  ? props.memberData.firstName : "" } | {props.memberData ? props.memberData.memberType : ""}</p>
             
            
          </ion-label>
      </div>

        <ion-item lines="none" href="/booking" >
          <div className={props.activeMenu[0]}>
            <img src="img/new-delivery.svg"/>
            <ion-label>New Delivery</ion-label>
          </div>
          
        </ion-item>
        <ion-item lines="none" href="/dashboard"> 
        <div className={props.activeMenu[1]}>
          <img src="img/dashboard.svg"/>
          <ion-label>Dashboard</ion-label>
        </div>
        </ion-item>
        <ion-item lines="none"  href="/deliveries" >
        <div className={props.activeMenu[2]}>
          <img src="img/all-deliveries.svg"/>
          <ion-label>All Deliveries</ion-label>
        </div>
        </ion-item>
        {/* <ion-item lines="none">
        <div className='sidemenu-list deactive'>
        <img src="img/lock.svg"/>
          <ion-label>Team Management</ion-label>
          </div>
        </ion-item> */}

        {/* <ion-item lines="none">
        <div className='sidemenu-list deactive'>
          <img src="img/lock.svg"/>
          <ion-label>Payment Methods</ion-label>
        </div>
        </ion-item> */}
        {/* <ion-item lines="none">
        <div className='sidemenu-list deactive'>
          <img src="img/lock.svg"/>
          <ion-label>Settings</ion-label>
        </div>
        </ion-item> */}
        <ion-item lines="none" onClick={() => { setIsOpen(true);}}>
        <div className='sidemenu-list' >
        <img src="img/support.svg"/>
          <ion-label>Support</ion-label>
        </div>
        </ion-item>
        <a href='/login' className='mob-logout'>Logout</a>
    </IonList>
</IonMenu>
<IonList className='sidebar-list'> 
        <ion-item lines="none" href="/booking" >
          <div className={props.activeMenu[0]}>
              <img src="img/new-delivery.svg"/>
            <ion-label>New Delivery</ion-label>
          </div>
          
        </ion-item>
        <ion-item lines="none" href="/dashboard"> 
        <div className={props.activeMenu[1]}>
          <img src="img/dashboard.svg"/>
          <ion-label>Dashboard</ion-label>
        </div>
        </ion-item>
        <ion-item lines="none"  href="/deliveries" >
        <div className={props.activeMenu[2]}>
          <img src="img/all-deliveries.svg"/>
          <ion-label>All Deliveries</ion-label>
        </div>
        </ion-item>
        {/* <ion-item lines="none">
        <div className='sidemenu-list deactive'>
         <img src="img/team.svg"/>
          <ion-label>Team Management</ion-label>
          </div>
        </ion-item>
        <ion-item lines="none">
        <div className='sidemenu-list deactive line'>
        <img src="img/payments.svg"/>
          <ion-label>Payment Methods</ion-label>
        </div>
        </ion-item>
        <ion-item lines="none">
        <div className='sidemenu-list deactive'>
        <img src="img/setting.svg"/>
          <ion-label>Settings</ion-label>
        </div>
        </ion-item> */}
        <ion-item lines="none" onClick={() => { setIsOpen(true);}}>
        <div className='sidemenu-list'>
        <img src="img/support.svg"/>
          <ion-label>Support</ion-label>
        </div>
        </ion-item>

    </IonList>

    <IonModal isOpen={isOpen}>
                 
                 <IonContent className="ion-padding view-details-popup">
                 
                 <div className='popup-header'>
                  <IonGrid>
                  <p  className='close-outline' onClick={() => setIsOpen(false)}>X</p>
                    <IonRow>
                      <IonCol size="7">
                        <h1>Support</h1>
                       
                      </IonCol>
                      <IonCol size="5">
                      
                        <p>support@rydesharing.com.sg</p>
                      </IonCol>
                    </IonRow>
                    
                  </IonGrid>
                </div>
                 <div className='order-summary view-details-popup'>
            
            <IonGrid>
              <div className='top-grid'>
              <IonRow>
                      <IonCol>
                        <p></p>
                      <input type="text" className='support-input' placeholder="Name " onChange={(e)=>{ setName(e.target.value)}}/>
                      <input type="text" className='support-input' placeholder="Email " onChange={(e)=>{ setEmail(e.target.value)}} />
                      <input type="text" className='support-input' placeholder="Mobile " onChange={(e)=>{ setPhone(e.target.value)}} />
                      <IonTextarea placeholder="Message" onIonChange={(e)=>{ setMessage(e.target.value)}} ></IonTextarea>
                      <IonButton color="primary"horizontal="end" size="medium" mode='ios' onClick={() => {sendEmail() }}>Submit Request</IonButton>
                      </IonCol>
                     
                    </IonRow>

              </div>
                    
                    
                  </IonGrid>
                  </div>
                 </IonContent>
               </IonModal>

      </>
  )
}

export default SidebarComponent